// Import the X (close) icon from `lucide-react` and the `CreateJobForm` component
import { X } from 'lucide-react';
import { CreateJobForm } from '../job/CreateJobForm';

// Define the props for the CreateJobModal component
interface CreateJobModalProps {
  onClose: () => void; // Callback to close the modal
  onSuccess: () => void; // Callback triggered on successful job creation
}

/**
 * A modal component for creating a new job posting.
 * Includes a form for job creation and a close button.
 */
export function CreateJobModal({ onClose, onSuccess }: CreateJobModalProps) {
  return (
    <div className="fixed inset-0 bg-background-dark bg-opacity-75 flex items-center justify-center p-4">
      {/* Modal Overlay */}
      <div className="bg-background-main rounded-lg max-w-2xl w-full p-6">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-primary-dark">
            Créer une nouvelle offre {/* Modal title */}
          </h2>
          <button
            onClick={onClose} // Trigger the `onClose` callback when clicked
            className="text-text-light hover:text-primary-main"
          >
            <X className="h-6 w-6" /> {/* Close icon */}
          </button>
        </div>
        
        {/* Job Creation Form */}
        <CreateJobForm
          onSuccess={onSuccess} // Trigger the `onSuccess` callback on successful form submission
          onCancel={onClose} // Trigger the `onClose` callback to cancel the operation
        />
      </div>
    </div>
  );
}
